import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useCompanyAttributeValues } from "@/lib/use-company-attribute-values"
import { useThreadsFilterState } from "../threads-filter-state"

export function CompanyStatusFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { companyStatuses, addCompanyStatus, removeCompanyStatus } =
		useThreadsFilterState()

	const { statuses: availableStatuses } = useCompanyAttributeValues()

	return (
		<>
			{availableStatuses.map((status) => (
				<CommandItem
					key={status.name}
					onSelect={() => {
						if (companyStatuses.includes(status.name)) {
							removeCompanyStatus(status.name)
						} else {
							addCompanyStatus(status.name)
						}
						onSelect()
					}}
				>
					<span className="flex w-full items-center gap-2">
						<span
							className="h-2 w-2 shrink-0 rounded-full"
							style={{ backgroundColor: status.color }}
						/>
						<span className="flex-1 truncate">{status.name}</span>
						<Check
							className={cn("h-4 w-4 shrink-0", {
								"opacity-100": companyStatuses.includes(status.name),
								"opacity-0": !companyStatuses.includes(status.name),
							})}
						/>
					</span>
				</CommandItem>
			))}
		</>
	)
}
